(function () {
  function getSourceIds(plugin) {
    if (!plugin || typeof plugin.getSources !== 'function') {
      return [];
    }

    try {
      return plugin.getSources({ query: 'a' }).map(function (source) {
        return source.sourceId;
      });
    } catch (error) {
      return [];
    }
  }

  function hasSourceId(plugin, sourceId) {
    return getSourceIds(plugin).indexOf(sourceId) >= 0;
  }

  function getLabels() {
    var translations =
      (window.algoliaShopify && window.algoliaShopify.translations) ||
      (window.algoliaShopify &&
        window.algoliaShopify.shopify &&
        window.algoliaShopify.shopify.market &&
        window.algoliaShopify.shopify.market.translations) ||
      {};

    return {
      collections: translations.collections || 'Categories',
      articles: translations.articles || 'Articles',
      pages: translations.pages || 'Pages',
      suggestions: translations.suggestions || 'Suggestions',
    };
  }

  // Used for headers we place directly in our custom main template
  // (the Autocomplete library does NOT wrap these, so we add the container).
  function renderSectionHeader(label, html) {
    return html`
      <div class="aa-SourceHeader aa-SourceHeader--beachgoer">
        <span class="aa-SourceHeaderTitle">${label}</span>
      </div>
    `;
  }

  // Used for source/plugin headers: the library already wraps the return value
  // in a `.aa-SourceHeader`, so we only emit the title to avoid double nesting
  // (double nesting double-applied the left inset and looked centered).
  function renderSectionHeaderTitle(label, html) {
    return html`<span class="aa-SourceHeaderTitle">${label}</span>`;
  }

  function toNumber(value) {
    var number = Number(value);

    return Number.isFinite(number) ? number : 0;
  }

  function productHasOnSaleTag(item) {
    if (!item || !item.tags) {
      return false;
    }

    if (Array.isArray(item.tags)) {
      return item.tags.some(function (tag) {
        return String(tag).toLowerCase() === 'on sale';
      });
    }

    return String(item.tags).toLowerCase().indexOf('on sale') !== -1;
  }

  function getSaleNumbers(item) {
    var price = toNumber(item.price);
    var compareAt = toNumber(item.compare_at_price);

    if (!(compareAt > price)) {
      var variantMin = toNumber(item.variants_min_price || item.price_min);
      var variantCompareMax = toNumber(
        item.variants_compare_at_price_max || item.compare_at_price_max
      );

      if (variantCompareMax > variantMin && variantMin > 0) {
        price = variantMin;
        compareAt = variantCompareMax;
      }
    }

    return { price: price, compareAt: compareAt };
  }

  function productIsOnSale(item) {
    if (!item) {
      return false;
    }

    if (productHasOnSaleTag(item)) {
      return true;
    }

    var price = toNumber(item.price);
    var compareAt = toNumber(item.compare_at_price);
    var priceMin = toNumber(item.variants_min_price || item.price_min || price);
    var compareAtMin = toNumber(
      item.compare_at_price_min || item.variants_compare_at_price_min
    );
    var compareAtMax = toNumber(
      item.compare_at_price_max || item.variants_compare_at_price_max
    );

    if (compareAt > price && price > 0) {
      return true;
    }

    if (compareAtMax > priceMin && priceMin > 0) {
      return true;
    }

    if (compareAtMin > priceMin && priceMin > 0) {
      return true;
    }

    return false;
  }

  function highlightTitle(html, title, query) {
    var text = title == null ? '' : String(title);

    if (!query) {
      return text;
    }

    var index = text.toLowerCase().indexOf(String(query).toLowerCase());

    if (index === -1) {
      return text;
    }

    var before = text.slice(0, index);
    var match = text.slice(index, index + query.length);
    var after = text.slice(index + query.length);

    return html`${before}<mark>${match}</mark>${after}`;
  }

  function renderContentLink(params, url) {
    var item = params.item;
    var html = params.html;
    var components = params.components;
    var query = (params.state && params.state.query) || '';
    var title;

    if (item._highlightResult && components && components.Highlight) {
      title = components.Highlight({ hit: item, attribute: 'title' });
    } else {
      title = highlightTitle(html, item.title, query);
    }

    return html`
      <a class="aa-ItemLink aa-ContentLink" href="${url}">
        <span class="aa-ContentLink-title">${title}</span>
      </a>
    `;
  }

  function renderProductHit(
    _defaultTemplate,
    templateOptions,
    distinct,
    itemLink,
    trackSearchAttribution
  ) {
    var html = templateOptions.html;
    var components = templateOptions.components;
    var item = templateOptions.item;
    var helpers = window.algoliaShopify.helpers;
    var image = helpers.renderImage(item, 125);
    var onSale = productIsOnSale(item);
    var sale = onSale ? getSaleNumbers(item) : null;
    var struck =
      sale && sale.compareAt > sale.price
        ? helpers.displayStrikedPrice(sale.price, sale.compareAt, item.currency)
        : '';
    var percent =
      sale && sale.compareAt > sale.price && sale.compareAt > 0
        ? Math.floor(((sale.compareAt - sale.price) / sale.compareAt) * 100)
        : 0;

    return html`
      <a
        href="${itemLink}"
        class="aa-ItemLink aa-ProductHit${onSale ? ' aa-ProductHit--on-sale' : ''}"
        onClick="${function () {
        trackSearchAttribution(item);
      }}"
      >
        <div class="aa-ProductHit-picture">
          <img src="${image.src}" srcset="${image.srcset}" sizes="${image.sizes}" alt="${item.title}" />
        </div>
        <div class="aa-ProductHit-text">
          <p class="aa-ProductHit-title">
            ${components.Highlight({ hit: item, attribute: 'title' })}
            <span class="aa-ProductHit-variant">${helpers.variantTitleAddition(item, distinct)}</span>
          </p>
          <p class="aa-ProductHit-price">
            ${onSale &&
      html`<span class="aa-ProductHit-tag" data-tag="Sale">Sale</span>`}
            <span class="aa-ProductHit-price-value">${helpers.displayPrice(item, distinct)}</span>
            ${struck &&
      html`<span class="aa-ProductHit-price-compare">${struck}</span>`}
            ${percent > 0 &&
      html`<span class="aa-ProductHit-price-discount">-${percent}%</span>`}
          </p>
        </div>
      </a>
    `;
  }

  function fetchShopifySuggest(query, resourceType, limit) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;

    return fetch(
      root +
      'search/suggest.json?q=' +
      encodeURIComponent(query) +
      '&resources[type]=' +
      resourceType +
      '&resources[limit]=' +
      limit
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        var results =
          (payload.resources &&
            payload.resources.results &&
            payload.resources.results[resourceType + 's']) ||
          [];

        return results.map(function (item) {
          return {
            title: item.title,
            handle: item.handle,
            url: item.url,
          };
        });
      })
      .catch(function () {
        return [];
      });
  }

  function createShopifyContentPlugin(options) {
    var config = window.algoliaShopify && window.algoliaShopify.config;

    return {
      getSources: function ({ query }) {
        if (!query) {
          return [];
        }

        var configLimit = (config && config[options.hitsKey]) || 0;
        // Shopify's suggest API caps each resource at 10.
        var limit = Math.min(10, Math.max(configLimit, options.defaultLimit || 6));

        return [
          {
            sourceId: options.sourceId,
            getItems: function () {
              return fetchShopifySuggest(query, options.resourceType, limit);
            },
            templates: {
              header: function ({ html }) {
                return renderSectionHeaderTitle(getLabels()[options.sourceId], html);
              },
              item: function (params) {
                return renderContentLink(params, params.item.url);
              },
            },
          },
        ];
      },
    };
  }

  function insertContentPlugins(plugins) {
    var articlesPlugin = createShopifyContentPlugin({
      sourceId: 'articles',
      resourceType: 'article',
      hitsKey: 'articles_autocomplete_hits_per_page',
      defaultLimit: 8,
    });
    var pagesPlugin = createShopifyContentPlugin({
      sourceId: 'pages',
      resourceType: 'page',
      hitsKey: 'pages_autocomplete_hits_per_page',
      defaultLimit: 8,
    });

    var cleaned = plugins.filter(function (plugin) {
      return !hasSourceId(plugin, 'articles') && !hasSourceId(plugin, 'pages');
    });

    var collectionsIndex = cleaned.findIndex(function (plugin) {
      return hasSourceId(plugin, 'collections');
    });
    var insertAt = collectionsIndex >= 0 ? collectionsIndex + 1 : cleaned.length;

    cleaned.splice(insertAt, 0, pagesPlugin, articlesPlugin);
    return cleaned;
  }

  function registerPanelSync() {
    var DESKTOP_PANEL_MEDIA = window.matchMedia('(min-width: 1024px)');
    var lockedPanelPosition = null;

    function getPanel() {
      return (
        document.querySelector('.aa-Panel:has(.aa-PanelLayout--beachgoer)') ||
        document.querySelector('.aa-Panel')
      );
    }

    function isPanelOpen() {
      var panel = getPanel();

      return panel && window.getComputedStyle(panel).display !== 'none';
    }

    function capturePanelPosition() {
      var searchBar = document.querySelector('.site-header-search-bar');

      if (!searchBar) {
        return null;
      }

      var rect = searchBar.getBoundingClientRect();

      // Document-space coordinates so the panel stays anchored to the search
      // box and scrolls with the page, rather than being pinned
      // to the viewport.
      return {
        left: rect.left + window.pageXOffset,
        top: rect.bottom - 1 + window.pageYOffset,
        width: rect.width,
      };
    }

    function applyPanelPosition(position) {
      if (!DESKTOP_PANEL_MEDIA.matches || !position) {
        return;
      }

      var panel = getPanel();

      if (!panel) {
        return;
      }

      var panelStyle = window.getComputedStyle(panel);
      if (panelStyle.display === 'none' || panelStyle.visibility === 'hidden') {
        lockedPanelPosition = null;
        return;
      }

      panel.style.setProperty('position', 'absolute', 'important');
      panel.style.setProperty('left', position.left + 'px', 'important');
      panel.style.setProperty('right', 'auto', 'important');
      panel.style.setProperty('width', position.width + 'px', 'important');
      panel.style.setProperty('max-width', position.width + 'px', 'important');
      panel.style.setProperty('top', position.top + 'px', 'important');
      panel.style.setProperty('transform', 'none', 'important');
      panel.style.setProperty('margin', '0', 'important');
    }

    function lockPanelPosition() {
      if (!DESKTOP_PANEL_MEDIA.matches) {
        return;
      }

      var position = capturePanelPosition();

      if (!position) {
        return;
      }

      lockedPanelPosition = position;
      applyPanelPosition(lockedPanelPosition);
    }

    function ensurePanelPosition() {
      if (!DESKTOP_PANEL_MEDIA.matches) {
        return;
      }

      if (lockedPanelPosition) {
        applyPanelPosition(lockedPanelPosition);
        return;
      }

      lockPanelPosition();
    }

    function scheduleEnsure() {
      if (!DESKTOP_PANEL_MEDIA.matches) {
        return;
      }

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(ensurePanelPosition);
      });
    }

    function handlePageScroll() {
      if (!DESKTOP_PANEL_MEDIA.matches || !isPanelOpen() || !lockedPanelPosition) {
        return;
      }

      applyPanelPosition(lockedPanelPosition);
    }

    function handleResize() {
      if (!DESKTOP_PANEL_MEDIA.matches) {
        lockedPanelPosition = null;
        return;
      }

      if (!isPanelOpen()) {
        lockedPanelPosition = null;
        return;
      }

      lockPanelPosition();
    }

    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handlePageScroll, { passive: true, capture: true });

    document.addEventListener('input', function (event) {
      if (
        event.target.matches &&
        event.target.matches('.aa-Input, [data-live-search-input], form[action="/search"] input')
      ) {
        scheduleEnsure();
      }
    });

    document.addEventListener('focusin', function (event) {
      if (
        event.target.matches &&
        event.target.matches('.aa-Input, [data-live-search-input], form[action="/search"] input')
      ) {
        lockedPanelPosition = null;
        scheduleEnsure();
      }
    });

    document.addEventListener('focusout', function (event) {
      if (
        event.target.matches &&
        event.target.matches('.aa-Input, [data-live-search-input], form[action="/search"] input')
      ) {
        window.setTimeout(function () {
          if (!isPanelOpen()) {
            lockedPanelPosition = null;
          }
        }, 200);
      }
    });

    document.addEventListener('algolia.autocomplete.afterInit', scheduleEnsure);
  }

  function registerLayoutAndTemplateHooks(hooks) {
    var translations = window.algoliaShopify.translations || {};

    window.algoliaShopify.translations = translations;
    translations.collections = 'Categories';
    translations.articles = translations.articles || 'Articles';
    translations.pages = translations.pages || 'Pages';

    hooks.registerHook(
      'beforeAutocompleteMainTemplate',
      function (_defaultTemplate, templateOptions, elements, displaySuggestions) {
        var html = templateOptions.html;
        var labels = getLabels();

        return html`
          <div class="aa-PanelLayout aa-Panel--scrollable aa-PanelLayout--beachgoer">
            <div class="aa-PanelSections aa-PanelSections--beachgoer">
              <div class="aa-PanelSection aa-PanelSection--products">
                ${elements.products}
              </div>
              <div class="aa-PanelSection aa-PanelSection--content">
                ${displaySuggestions &&
          html`
                  ${renderSectionHeader(labels.suggestions, html)}
                  ${elements.querySuggestionsPlugin}
                `}
                ${elements.collections}
                ${elements.pages}
                ${elements.articles}
                ${elements.redirectUrlPlugin}
              </div>
            </div>
          </div>
        `;
      }
    );

    hooks.registerHook(
      'beforeAutocompleteMainProductsTemplate',
      function (_defaultTemplate, templateOptions, elements) {
        var html = templateOptions.html;

        return html`
          <div
            class="aa-PanelLayout aa-Panel--scrollable aa-PanelLayout--beachgoer aa-PanelLayout--products-only"
          >
            <div class="aa-PanelSection aa-PanelSection--products">
              ${elements.products}
            </div>
          </div>
        `;
      }
    );

    hooks.registerHook(
      'beforeAutocompletePluginOptions',
      function (options, context) {
        var perPage = {
          products: 12,
          collections: 8,
          pages: 8,
          articles: 8,
        };
        var name = context && context.pluginName;

        if (name && perPage[name] && options && options.searchParameters) {
          options.searchParameters.hitsPerPage = perPage[name];
        }

        return options;
      }
    );

    hooks.registerHook('beforeAutocompleteProductTemplate', renderProductHit);

    hooks.registerHook(
      'beforeAutocompleteHeaderTemplate',
      function (_defaultTemplate, templateOptions, title) {
        var html = templateOptions.html;
        var label = title == null ? '' : String(title);

        if (/collection/i.test(label)) {
          label = 'Categories';
        }

        return renderSectionHeaderTitle(label, html);
      }
    );

    hooks.registerHook(
      'beforeAutocompleteCollectionsTemplate',
      function (_defaultTemplate, templateOptions, itemLink) {
        return renderContentLink(templateOptions, itemLink);
      }
    );

    hooks.registerHook(
      'beforeAutocompleteArticlesTemplate',
      function (_defaultTemplate, templateOptions, itemLink) {
        return renderContentLink(templateOptions, itemLink);
      }
    );

    hooks.registerHook(
      'beforeAutocompletePagesTemplate',
      function (_defaultTemplate, templateOptions, itemLink) {
        return renderContentLink(templateOptions, itemLink);
      }
    );
  }

  // -------------------------------------------------------------------------
  // InstantSearch results page enhancements.
  // Hits are rendered client-side and re-rendered on every search / filter /
  // pagination change, so we observe the results container and idempotently
  // decorate each product card (currently: a "Sale" badge for on-sale items).
  // -------------------------------------------------------------------------
  function decorateInstantSearchHit(hit) {
    if (!hit || hit.getAttribute('data-bg-decorated') === '1') {
      return;
    }
    hit.setAttribute('data-bg-decorated', '1');

    // The app already renders a struck compare-at price for on-sale products;
    // a non-empty value is the most reliable on-sale signal in the DOM.
    var struck = hit.querySelector('.ais-hit--price-striked');
    var onSale = !!struck && struck.textContent.replace(/\s/g, '').length > 0;

    if (onSale && !hit.querySelector('.ais-hit--sale-badge')) {
      var price = hit.querySelector('.ais-hit--price');

      if (price) {
        var badge = document.createElement('span');
        badge.className = 'ais-hit--sale-badge';
        badge.textContent = 'Sale';
        price.insertAdjacentElement('afterend', badge);
      }
    }

    // The app renders the discount as "- 4 %" (awkward spacing). Tighten it to
    // "-4%"; the red color is applied via CSS.
    var discount = hit.querySelector('.ais-hit--price-discount');
    if (discount) {
      var tightened = discount.textContent.replace(/\s+/g, '');
      if (tightened && tightened !== discount.textContent) {
        discount.textContent = tightened;
      }
    }
  }

  function decorateAllInstantSearchHits(container) {
    var hits = container.querySelectorAll('.ais-hit.ais-product');

    for (var i = 0; i < hits.length; i++) {
      decorateInstantSearchHit(hits[i]);
    }
  }

  function setupInstantSearchEnhancements(container) {
    var scheduled = false;

    function flush() {
      scheduled = false;
      decorateAllInstantSearchHits(container);
    }

    decorateAllInstantSearchHits(container);

    var observer = new MutationObserver(function () {
      if (scheduled) {
        return;
      }
      scheduled = true;
      window.requestAnimationFrame(flush);
    });

    observer.observe(container, { childList: true, subtree: true });
  }

  function initInstantSearchEnhancements() {
    var selector = '.ais-hits, .ais-hits-container';
    var existing = document.querySelector(selector);

    if (existing) {
      setupInstantSearchEnhancements(existing);
      return;
    }

    var tries = 0;
    var timer = window.setInterval(function () {
      var container = document.querySelector(selector);

      if (container) {
        window.clearInterval(timer);
        setupInstantSearchEnhancements(container);
      } else if (++tries > 40) {
        window.clearInterval(timer);
      }
    }, 300);
  }

  // -------------------------------------------------------------------------
  // Search submit button fix.
  // Algolia Autocomplete replaces the theme's native "q" input with its own
  // ".aa-Input" (which has no name), so the theme's submit button ends up
  // submitting an empty "#header-search-form". Pressing Enter works because it
  // submits Autocomplete's own ".aa-Form" (which navigates to /search?q=...).
  // We intercept the button click and submit that same ".aa-Form" instead.
  // -------------------------------------------------------------------------
  function initSearchSubmitFix() {
    document.addEventListener(
      'click',
      function (event) {
        var button =
          event.target &&
          event.target.closest &&
          event.target.closest('[data-live-search-submit]');

        if (!button) {
          return;
        }

        var scope =
          button.closest('.site-header-search') ||
          button.closest('.site-header-search-bar') ||
          document;
        var form = scope.querySelector('.aa-Form');

        // No Autocomplete form present: leave the native submit behavior alone.
        if (!form) {
          return;
        }

        event.preventDefault();

        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit();
        } else {
          form.dispatchEvent(
            new Event('submit', { cancelable: true, bubbles: true })
          );
        }
      },
      true
    );
  }

  // -------------------------------------------------------------------------
  // Search page title fix.
  // Algolia rewrites document.title at runtime to `Search: {n} for "{query}"`.
  // We restore the expected phrasing: `Search: {n} results found for "{query}"`.
  // -------------------------------------------------------------------------
  function initSearchTitleFix() {
    var titleEl = document.querySelector('title');

    if (!titleEl) {
      return;
    }

    function rewrite() {
      var text = titleEl.textContent;

      if (
        /^\s*Search:/.test(text) &&
        /\bfor\s+["\u201c]/.test(text) &&
        !/results found/i.test(text)
      ) {
        var fixed = text.replace(/\s+for\s+(["\u201c])/, ' results found for $1');

        if (fixed !== text) {
          titleEl.textContent = fixed;
        }
      }
    }

    rewrite();

    var observer = new MutationObserver(rewrite);
    observer.observe(titleEl, {
      childList: true,
      characterData: true,
      subtree: true,
    });
  }

  // -------------------------------------------------------------------------
  // Search placeholder.
  // Algolia Autocomplete swaps the theme's native input (which has a
  // placeholder) for its own ".aa-Input", which renders with none. Restore it,
  // and reapply when Autocomplete re-mounts (e.g. detached/mobile mode).
  // -------------------------------------------------------------------------
  function initSearchPlaceholder() {
    var PLACEHOLDER = 'What are you looking for?';

    function apply() {
      var inputs = document.querySelectorAll('.aa-Input');
      for (var i = 0; i < inputs.length; i++) {
        if (inputs[i].getAttribute('placeholder') !== PLACEHOLDER) {
          inputs[i].setAttribute('placeholder', PLACEHOLDER);
        }
      }

      var buttons = document.querySelectorAll(
        '.aa-DetachedSearchButtonPlaceholder'
      );
      for (var j = 0; j < buttons.length; j++) {
        if (!buttons[j].textContent.trim()) {
          buttons[j].textContent = PLACEHOLDER;
        }
      }
    }

    apply();

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) {
        return;
      }
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        apply();
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState !== 'loading') {
    initInstantSearchEnhancements();
    initSearchSubmitFix();
    initSearchTitleFix();
    initSearchPlaceholder();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initInstantSearchEnhancements();
      initSearchSubmitFix();
      initSearchTitleFix();
      initSearchPlaceholder();
    });
  }

  document.addEventListener('algolia.hooks.initialize', initAlgoliaHooks);

  // Initialize immediately if Algolia loaded before this script
  if (document.readyState !== 'loading') {
    initAlgoliaHooks();
  } else {
    document.addEventListener('DOMContentLoaded', initAlgoliaHooks);
  }

  function initAlgoliaHooks() {
    var config = window.algoliaShopify && window.algoliaShopify.config;

    if (!config || !window.algoliaShopify.hooks) {
      return;
    }

    if (window.algoliaShopify.hooks.__beachgoerInit) {
      return;
    }

    window.algoliaShopify.hooks.__beachgoerInit = true;

    registerLayoutAndTemplateHooks(window.algoliaShopify.hooks);
    registerPanelSync();

    var useShopifySuggest = !config.index_articles || !config.index_pages;

    if (!useShopifySuggest) {
      return;
    }

    config.index_articles = true;
    config.index_pages = true;

    if (!config.articles_autocomplete_hits_per_page) {
      config.articles_autocomplete_hits_per_page = 6;
    }

    if (!config.pages_autocomplete_hits_per_page) {
      config.pages_autocomplete_hits_per_page = 6;
    }

    window.algoliaShopify.hooks.registerHook(
      'beforeAutocompletePluginsArray',
      function () {
        var plugins = Array.prototype.slice.call(arguments).filter(Boolean);
        return insertContentPlugins(plugins);
      }
    );
  }
})();
